export default __webpack_public_path__ + "static/media/open-link-w.0f2b6fe7.svg";